module.exports = __webpack_public_path__ + "static/media/txt.528e2946.png";